var render, staticRenderFns
import script from "./CardSmallChart.vue?vue&type=script&lang=js&"
export * from "./CardSmallChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68871b6",
  null
  
)

export default component.exports